import { HomeServiceDashboardRow } from "generated/openApi";
import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import ApiService from "services/apiService";
import { ServicePeriod } from "../types";


interface ServiceDataContextValue {
    thisMonthRows: HomeServiceDashboardRow[] | undefined;
    previousMonthRows: HomeServiceDashboardRow[] | undefined;
    loading: boolean;
    selectedPeriod: ServicePeriod;
    updateSelectedPeriod: (period: ServicePeriod) => void;
    currentRows: HomeServiceDashboardRow[] | undefined;
    refetch: () => void;
}

const ServiceDataContext = createContext<ServiceDataContextValue | undefined>(undefined);

interface ServiceDataProviderProps {
    children: ReactNode;
}

export const ServiceDataProvider = ({ children }: ServiceDataProviderProps) => {
    const [thisMonthRows, setThisMonthRows] = useState<HomeServiceDashboardRow[] | undefined>(undefined);
    const [previousMonthRows, setPreviousMonthRows] = useState<HomeServiceDashboardRow[] | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedPeriod, setSelectedPeriod] = useState<ServicePeriod>("thisMonth");

    useEffect(() => {
        fetch();
    }, []);

    const fetch = () => {
        setLoading(true);
        ApiService.home.getServiceDashboard().then((response) => {
            setThisMonthRows(response.thisMonthRows);
            setPreviousMonthRows(response.previousMonthRows);
            setLoading(false);
            setLoading(false);
        }).catch((error) => {
            console.error("Failed to fetch service dashboard:", error);
            setLoading(false);
        });
    };

    const currentRows = selectedPeriod === "thisMonth" ? thisMonthRows : previousMonthRows;

    const value: ServiceDataContextValue = {
        thisMonthRows,
        previousMonthRows,
        loading,
        selectedPeriod,
        updateSelectedPeriod: setSelectedPeriod,
        currentRows,
        refetch: fetch,
    };

    return (
        <ServiceDataContext.Provider value={value}>
            {children}
        </ServiceDataContext.Provider>
    );
};

export const useServiceData = (): ServiceDataContextValue => {
    const context = useContext(ServiceDataContext);
    if (context === undefined) {
        throw new Error("useServiceData must be used within a ServiceDataProvider");
    }
    return context;
};